export type ChatChannelState = 'idle' | 'connecting' | 'open' | 'reconnecting' | 'failed' | 'ended';

export interface ChatEntry {
  readonly id: string;
  readonly sender: 'self' | 'peer';
  readonly text: string;
  readonly sentAt: number;
}

export interface ChatSnapshot {
  readonly state: ChatChannelState;
  readonly messages: readonly ChatEntry[];
  readonly unreadCount: number;
  readonly peerTyping: boolean;
}

export type ChatErrorCode = 'invalid-channel' | 'invalid-message' | 'channel-error' | 'send-failed';

export class ChatError extends Error {
  constructor(
    readonly code: ChatErrorCode,
    message: string,
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = 'ChatError';
  }
}

export interface ChatEvents {
  readonly change: { readonly snapshot: ChatSnapshot };
  readonly error: { readonly error: ChatError };
}

export type ChatSendFailureReason = 'empty' | 'too-long' | 'unavailable' | 'send-failed';

export type ChatSendResult =
  | { readonly ok: true; readonly message: ChatEntry }
  | { readonly ok: false; readonly reason: ChatSendFailureReason };
